//抽奖item实体
export interface LotteryItemEntity {
    type : number;//类型  1 对应物品解锁，2 钱币奖励
    imgPathStr : string;//
    defineStr : string;//定义  龙 ， 1000
    weight : number ;//权重
}
/**
 * 抽奖Manager
 */
export default class LotteryManager {

    constructor( ) {
        this.prizeConfig = prizeConfig();
        for( let lotteryItemEntity of this.prizeConfig ){
            this.allWeight += lotteryItemEntity.weight;
        }
    }

    prizeConfig : LotteryItemEntity[] ;
    allWeight : number = 0;

    /**
     * 获取抽奖结果
     */
    getLotteryResult( needCount : number ) : LotteryItemEntity[]{
        let retData : LotteryItemEntity[] = [];
        for ( let i = 0 ; i < needCount ; i ++ ) {
            retData.push( this._getOnePrizeResult() );
        }
        return retData;
    }

    /**
     * 获取一个奖品结果
     */
    private _getOnePrizeResult() : LotteryItemEntity {
        let randomInt = Math.floor( Math.random() * this.allWeight );
        for ( let i = 0 ; i < this.prizeConfig.length ; i ++ ) {
            if ( randomInt <= this.prizeConfig[i].weight ) {
                return this.prizeConfig[i];
            }
            randomInt -= this.prizeConfig[i].weight;
        }
    }

}

export function prizeConfig() : LotteryItemEntity[]{
    const dataJson : LotteryItemEntity[] = [
        // {type : 1 , defineStr : "鼠" , weight : 5  },
        // {type : 1 , defineStr : "牛" , weight : 5  },
        // {type : 1 , defineStr : "虎" , weight : 5  },
        // {type : 1 , defineStr : "兔" , weight : 1  },
        // {type : 1 , defineStr : "龙" , weight : 5  },
        // {type : 1 , defineStr : "蛇" , weight : 5  },
        // {type : 1 , defineStr : "马" , weight : 5  },
        // {type : 1 , defineStr : "羊" , weight : 5  },
        // {type : 1 , defineStr : "猴" , weight : 5  },
        // {type : 1 , defineStr : "鸡" , weight : 5  },
        // {type : 1 , defineStr : "狗" , weight : 5  },
        // {type : 1 , defineStr : "猪" , weight : 5  },
        {type : 2 , imgPathStr:"1" ,defineStr : "0" , weight : 100  },
        {type : 2 , imgPathStr:"2" , defineStr : "0.5" , weight : 100  },
        {type : 2 , imgPathStr:"3" ,defineStr : "1" , weight : 120  },
        {type : 2 , imgPathStr:"4" ,defineStr : "2" , weight : 50  },
        {type : 2 , imgPathStr:"5" ,defineStr : "5" , weight : 20  },
        {type : 2 , imgPathStr:"6" ,defineStr : "999" , weight : 10  },
    ];
    return dataJson;
}
